import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import Routes from "./Routes";
import "./App.css";


class App extends Component {
    render() {
        const childProps = {
        };

        return (
            <div className="app" >
                <div className="center-block w-xxl w-auto-xs p-y-md">
                    <div className="navbar">
                        <div className="pull-center">
                            <a className="navbar-brand">
                                <img style={{ maxHeight:60 }} src="https://d6ca5q2o2y1xg.cloudfront.net/static/images/logo_main.png"
                                     alt="flatfair"></img></a>
                        </div>
                    </div>
                    <Routes childProps={childProps}/>
                </div>
            </div>
        );
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js